<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        duringChange() === 't' }">
    </div>
    <img class="control__img bg-style bg-style__icon border-light"
         [ngClass]="{ 'bg-inactive': duringChange() === 't',
             'bg-style': duringChange() === 'f' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
         width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': duringChange() === 't',
            'bg-style': duringChange() === 'f',
            'bg-style__label': duringChange() === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <div class="control__content datepicker" data-testid="date-picker-1">
        <h4 class="color-basic">
            {{ subtitle(4364) + ': ' + timeDate.dateStart }}
        </h4>
        <app-date-picker
                [newDate]="newDateStart"
                (dateChange)="changeDateStart($event)">
        </app-date-picker>
    </div>
    <div class="datepicker" data-testid="date-picker-2">
        <h4 class="color-basic">
            {{ subtitle(4365) + ': ' + timeDate.dateEnd }}
        </h4>
        <app-date-picker
                [newDate]="newDateEnd"
                (dateChange)="changeDateEnd($event)">
        </app-date-picker>
    </div>
    <div class="control__group-btn control__group-btn--column"
         *ngIf="control.elementVal.getValue()?.params.remoteReset
            && control.elementVal.getValue()?.params.startDay > 0
            && control.elementVal.getValue()?.params.startMonth > 0
            && control.elementVal.getValue()?.params.endDay > 0
            && control.elementVal.getValue()?.params.endMonth > 0"
        data-testid="remoteReset">
        <p class="font-18 font-bold color-basic">{{ subtitle(3960) }}</p>
        <p class="font-15 color-basic">
            <span>
                {{ control.elementVal.getValue()?.params.startDay
                    + '-' + control.elementVal.getValue()?.params.startMonth
                    + '-' + control.elementVal.getValue()?.params.startYear }}
            </span>
            <span> : </span>
            <span>
                {{ control.elementVal.getValue()?.params.endDay
                    + '-' + control.elementVal.getValue()?.params.endMonth
                    + '-' + control.elementVal.getValue()?.params.endYear }}
            </span>
        </p>
        <button class="control__button bg-cancel font-15 color-light"
            (click)="timeDate.returnPickersDate(true)">
            <span class="control__datepicker-set-now">{{ subtitle(1809) }}</span>
        </button>
    </div>
    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="timeDate.setDatePickers()">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/return.svg"
                 width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': duringChange() === 't',
                'bg-ok': duringChange() === 'f',
                'bg-ok--accept': duringChange() === 'f' }"
                data-testid="sendButton"
                (click)="timeDate.returnPickersDate(false)">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/ok.svg"
                width="40" height="40" alt="" />
        </button>
    </div>
    <div *ngIf="duringChange() === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
